export default {
    infoWork: 'Successfully',
    time: 'Time',
    now: 'Now',
    confirm: 'Confirm'
}
